import { dispatchWindowEvent } from "./_utils.js";

export default class DictionaryIndex
{
    constructor() {


        const onRightPage = document.body.classList.contains( 'dictionnaire-jeu-index' );
        if ( !onRightPage ) {
            // nothing to do.
            return;
        }


        this.compilePossibleAudios();

        if ( this.possibleAudios.length > 0 ) {
            this.playRandomAudio();
        }

    }

    compilePossibleAudios() {
        const nationLinks = [ ...document.querySelectorAll( '.nations-list .nation-link' ) ];

        this.possibleAudios = [];

        nationLinks.forEach( nation => {
            const audio = nation.dataset.audio;

            if ( audio && audio.length > 0 ) {
                this.possibleAudios.push( audio );
            }
        } )

    }

    playRandomAudio() {


        const wantedAudio = this.possibleAudios[ Math.floor( Math.random() * this.possibleAudios.length ) ];

        dispatchWindowEvent( 'audiomanager:playsound', {
            url: wantedAudio,
        } )
    }

}
